import React, { useContext } from 'react';
import Typography from '@mui/material/Typography'; // Assurez-vous que Typography est importé correctement
import CheckoutForm from './CheckoutForm'; // Assurez-vous que CheckoutForm est bien importé
import { CartContext } from '../context/CartContext';
import { useT } from '../i18n';
import { Helmet } from 'react-helmet-async';
import { titreSeo } from './Seo';

const Checkout = () => {
  const { cart } = useContext(CartContext);
  const t = useT('checkout');

  // Page utilitaire : son propre titre, et jamais dans les moteurs, quelle que soit la langue (comme le panier).
  const head = (
    <Helmet>
      <title>{titreSeo(t('checkout.title'))}</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  );

  // Si le panier est vide, afficher un message ou rediriger
  if (cart.length === 0) {
    return <>{head}<Typography variant="h5">{t('checkout.empty')}</Typography></>;
  }

  return (
    <div className="container my-5 checkout-page">
      {head}
      <Typography variant="h2">{t('checkout.title')}</Typography>
      {cart.length > 0 && <CheckoutForm />} {/* Afficher le formulaire de paiement ici */}
    </div>
  );
};

export default Checkout;
